import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow } from "swiper/modules";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-coverflow";
import "./ProductSlider.css";
import { BASE_URL } from "../../../constant";

function ProductSlider({ activeColor }) {
  console.log("ProductSlider received activecolor:", activeColor);
  const [swiperInstance, setSwiperInstance] = useState(null);
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        let url = `${BASE_URL}/api/customProducts/color/`;
        if (activeColor) {
          url += `${activeColor}`;
        }

        const response = await axios.get(url);
        console.log("Fetched products:", response.data); // Debugging
        setProducts(response.data);
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    console.log("Active color changed:", activeColor); // Debugging
    fetchProducts();
  }, [activeColor]);

  useEffect(() => {
    if (swiperInstance && products.length > 1) {
      swiperInstance.slideTo(1, 0);
    }
  }, [activeColor, swiperInstance, products]);

  const handleProductClick = (productId) => {
    navigate(`/productdetails/${productId}`);
  };

  return (
    <div>
      {activeColor && (
        <h3
          style={{
            textAlign: "center",
            fontWeight: "bold",
            textTransform: "uppercase",
          }}
        >
          Showing products in {activeColor}
        </h3>
      )}
      <Swiper
        onSwiper={setSwiperInstance}
        effect={"coverflow"}
        navigation={true}
        centeredSlides
        modules={[Navigation, EffectCoverflow]}
        slidesPerView={"auto"}
        initialSlide={2}
        spaceBetween={10}
        grabCursor
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 0,
          modifier: 1,
          slideShadows: false,
        }}
        style={{ padding: "30px 0" }}
      >
        {products.map((product) => (
          <SwiperSlide
            key={product.productId}
            className="productslide"
            onClick={() => handleProductClick(product.productId)}
          >
            <img src={product.prodImg1} alt={product.productName} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default ProductSlider;
